import PageHead from "./Head";
import Context from "@/context/Context";
import AppealPage from "@/my_components/_Appeal/AppealPage";

// Deliberately public (no withAuthSSR) -- an account-suspension appeal must be reachable by a
// user whose own Sanctum token was already revoked the moment they were suspended, so this
// page can never assume an authenticated session. See AppealPage.js's own docblock.
const Appeal = () => {
  return (
      <Context>
        <PageHead title="Submit an Appeal | SmartTech Academy" description="Appeal an event takedown or account suspension." />
        <AppealPage />
      </Context>
  );
};

export default Appeal;
